import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import { Card, CardBody, Col, Row, UncontrolledTooltip } from "reactstrap";
import { RiBuilding2Line, RiBuilding4Line, RiInformationLine, RiLineChartLine, RiMapPinLine } from "react-icons/ri";
import { buildNestedObject } from "../../helpers";
import { KeysTitles } from "../../constants";

const Overview = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    if (detailsQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const generic = buildNestedObject(organizationData?.additional_information?.generic || []);

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('overview')}
            className={activeAccordion === 'overview' ? 'active' : ''}
            eventKey={'overview'}
        >
            <Accordion.Header>
                <RiBuilding2Line size="24" className="me-2" />
                <span>
                    {t('Additional Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                {/* Company Basics (misc) */}
                <Card className="h-100 h-100 shadow-sm mb-4">
                    <CardBody className="p-1">
                        <div className="d-flex align-items-center mb-2">
                            <span className="me-2 text-primary">
                                <RiBuilding4Line size="24" />
                            </span>
                            <div className="fw-bold font-size-16">
                                {t('Company Basics')}
                            </div>
                        </div>

                        <Row>
                            {Object.entries(generic.misc || {}).map(([key, value]) => (
                                <Col md="6" key={key} className="mb-2">
                                    <div className="mb-1">
                                        <strong
                                            className="me-1"
                                        >
                                            {t(KeysTitles[key]?.title || key)}
                                            {KeysTitles[key]?.description ? (
                                                <>
                                                    {' '}
                                                    <span
                                                        id={`tooltip-basics-${key}`}
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target={`tooltip-basics-${key}`}
                                                    >
                                                        {t(KeysTitles[key].description)}
                                                    </UncontrolledTooltip>
                                                </>
                                            ) : null}:
                                        </strong>{' '}

                                        {KeysTitles[key]?.valuesOptions ? (
                                            `${value} (${t(KeysTitles[key].valuesOptions[value])})`
                                        ) : value}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>

                {/* Trends */}
                <Card className="h-100 h-100 shadow-sm mb-4">
                    <CardBody className="p-1">
                        <div className="d-flex align-items-center mb-2">
                            <span className="me-2 text-primary">
                                <RiLineChartLine size="24" />
                            </span>

                            <div className="fw-bold font-size-16">
                                {t('Business Trends')}
                            </div>
                        </div>

                        <Row>
                            {Object.entries(generic.trends || {}).map(([key, value]) => (
                                <Col md="6" key={key} className="mb-2">
                                    <strong
                                        className="me-1"
                                    >
                                        {t(KeysTitles[key]?.title || key)}
                                        {KeysTitles[key]?.description ? (
                                            <>
                                                {' '}
                                                <span
                                                    id={`tooltip-basics-${key}`}
                                                    style={{ cursor: "pointer" }}>
                                                    <RiInformationLine />
                                                </span>
                                                <UncontrolledTooltip
                                                    target={`tooltip-basics-${key}`}
                                                >
                                                    {t(KeysTitles[key].description)}
                                                </UncontrolledTooltip>
                                            </>
                                        ) : null}:
                                    </strong>{' '}

                                    {KeysTitles[key]?.valuesOptions ? (
                                        `${value} (${t(KeysTitles[key].valuesOptions[value])})`
                                    ) : value}
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>

                {/* GPS Coordinates */}
                <Card className="h-100 h-100 shadow-sm mb-4">
                    <CardBody className="p-1">
                        <div className="d-flex align-items-center mb-2">
                            <span className="me-2 text-primary">
                                <RiMapPinLine size="24" />
                            </span>

                            <div className="fw-bold font-size-16">
                                {t('Location Coordinates')}
                            </div>
                        </div>

                        <Row>
                            {Object.entries(generic.gpsCoordinates || {}).map(([key, value]) => (
                                <Col md="6" key={key} className="mb-2">
                                    <strong>
                                        {t(KeysTitles[key]?.title || key)}:
                                    </strong> {value}
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    Overview
)